export const environment = {
  production: false,
  apiUrl: "https://api-dev.lakerja.net/api", // mid tier asah skill development 03
  apiUrlUjiSkill: "https://edtechin.com/api", // mid tier uji skill develoment 03
};
